import { cn } from "~/utils/shadecn"

// SFW visibility policy
// ---------------------
// For now we treat payment verification as the single proxy for age verification —
// we only unblur NSFW content (avatars + stills) for members who are age-verified
// through a successful payment event. `isPaymentVerified` is the only viewer-side
// flag these helpers read. Stars/videos flagged SFW are unblurred for everyone.
//
// Network-level privacy: handled separately by `gateStillsToUser` in
// app/models/videos.server.ts (which strips Stills URLs from anon payloads for
// non-SFW videos) and by the pre-blurred `Videos.BlurredStill` asset shipped
// in their place.
//
// Visual blur strategy:
//   - Avatars: CSS blur-lg only. There is no pre-blurred avatar asset.
//   - Video stills (VideoCard): pre-blurred BlurredStill AS the src + CSS
//     blur-lg layered on top. The server-side blur (sharp().blur(20) in
//     app/workers/workers.server.ts) is too soft on its own for the preview
//     card use case, so the CSS layer is intentional. If the encoder is ever
//     retuned to a stronger blur (smaller resize / higher sigma), the CSS
//     layer in VideoCard can be removed.

export function shouldBlurAvatar(isPaymentVerified?: boolean, isSFW?: boolean) {
  return !isPaymentVerified && !isSFW
}

export function avatarImageClassName(isPaymentVerified?: boolean, isSFW?: boolean, baseClassName = "object-cover") {
  return cn(baseClassName, shouldBlurAvatar(isPaymentVerified, isSFW) && "blur-lg")
}

export function shouldUseBlurredStill(isPaymentVerified?: boolean, sfwStills?: boolean) {
  return !isPaymentVerified && !sfwStills
}
